import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPiuMeno = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1000px",
	height: "1000px",
	viewBox: "0 0 1000 1000",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "Group 12" }), /* @__PURE__ */ _jsx("g", {
		id: "10.-Checker",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Group-12",
			children: [/* @__PURE__ */ _jsx("rect", {
				id: "icon_Background",
				x: 0,
				y: 0,
				width: 1e3,
				height: 1e3
			}), /* @__PURE__ */ _jsx("path", {
				d: "M524.388889,566.333333 L524.388889,466.833333 L621.888889,466.833333 L621.888889,432.833333 L524.388889,432.833333 L524.388889,333.333333 L486.388889,333.333333 L486.388889,432.833333 L388.888889,432.833333 L388.888889,466.833333 L486.388889,466.833333 L486.388889,566.333333 L524.388889,566.333333 Z M621.888889,642.333333 L621.888889,608.333333 L388.888889,608.333333 L388.888889,642.333333 L621.888889,642.333333 Z",
				id: "\\xB1",
				fill: "#424548",
				fillRule: "nonzero"
			})]
		})
	})]
});
export default SvgPiuMeno;
